import "./fab.css";
import whatsappIcon from "../../asset/icon/Digital_Glyph_White.png";

function FAB() {
  const phoneNumber = "60183768233";

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fab"
      aria-label="Chat on WhatsApp"
    >
      <img
        src={whatsappIcon}
        alt="WhatsApp"
        className="fab-icon"
      />
    </a>
  );
}

export default FAB;